'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".GiftTracking-module_landscapeContainer__UrexN{align-items:center;display:flex;justify-content:center;margin-bottom:0;width:auto}.GiftTracking-module_landscapeContainer__UrexN.GiftTracking-module_showSharingOptions__RytW4{margin-bottom:1.25rem}.GiftTracking-module_sharingTruckContainer__os7kI{justify-content:center;width:2rem}.GiftTracking-module_bannerContainer__roPjy{flex-grow:1;justify-content:top;padding-left:1rem}";
var styles = {"landscapeContainer":"GiftTracking-module_landscapeContainer__UrexN","showSharingOptions":"GiftTracking-module_showSharingOptions__RytW4","sharingTruckContainer":"GiftTracking-module_sharingTruckContainer__os7kI","bannerContainer":"GiftTracking-module_bannerContainer__roPjy"};
styleInject["default"](css_248z, '96bd03cf-c886-45c9-ac82-b6a860fca905');

exports["default"] = styles;
